<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="姓名" class="fn-left">
            <el-input v-model="listQuery.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="部门" class="fn-left">
            <department-select :selected.sync="listQuery.departmentId" />
          </el-form-item>
          <el-form-item label="状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.status" :data="exchangeStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetHistoryList()">查询 </el-button>
            <el-button type="success" @click="fnPopExchange()">确认交易</el-button>
            <el-button type="primary" @click="fnPopPayment()">确认打款</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table ref="multipleTable" :key="tableKey" :data="exchangeLists" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column label="部门" prop="department_name" align="center" />
        <el-table-column label="职位" prop="title" align="center" />
        <el-table-column label="出售时间" prop="create_time" align="center" />
        <el-table-column label="出售股数" align="center">
          <template slot-scope="{row}">
            <span>{{ row.sale_shares/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出售股价" align="center">
          <template slot-scope="{row}">
            <span>{{ (row.share_price * 100) /10000 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出售市值" align="center">
          <template slot-scope="{row}">
            <span>{{ row.sale_price/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易状态" prop="status_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 4" type="text" @click="fnLookPayProof(row.voucher)">查看凭证</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetHistoryList" />
    </div>
    <el-dialog title="确认打款" :visible.sync="bShowPaymentDialog" width="500px">
      <el-form ref="confirmPaymentForm" :model="confirmPaymentForm" :rules="confirmPaymentRule">
        <el-form-item label="打款日期" prop="time">
          <el-date-picker v-model="confirmPaymentForm.time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 300px;" />
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="confirmPaymentForm.remark" type="textarea" placeholder="请输入" style="width: 300px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitConfirmPayment">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看凭证" :visible.sync="bShowCertificate" width="500px">
      <div v-html="currentCertify" />
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitConfirmPayment">确定</el-button>
      </div> -->
    </el-dialog>
  </div>

</template>

<script>

import DepartmentSelect from './DepartmentSelect'
import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import { validateRequire } from '@/utils/validate'

const defaultconfirmPaymentForm = {
  deal_id: '',
  voucher: '',
  remark: '',
  time: ''
}

export default {
  name: 'StockExerciseExchangeLists',
  components: {
    Select,
    DepartmentSelect
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      exchangeLists: [],
      stockTypes: commondata.STOCK_TYPE,
      bCreateSendEmployee: false,
      departmentList: [],
      confirmPaymentForm: Object.assign({}, defaultconfirmPaymentForm),
      bShowCertificate: false,
      listQuery: {
        p: 0,
        limit: 20,
        name: '',
        departmentId: '',
        status: '',
        begin_time: '',
        end_time: '',
        total: 0
      },
      exchangeStatus: commondata.EXCHANGE_STATUS,
      confirmPaymentRule: {
        remark: [{ validator: validateRequire, trigger: 'manual', message: '备注说明' }],
        time: [{ validator: validateRequire, trigger: 'manual', message: '打款日期' }]
      },
      bShowPaymentDialog: true,
      currentCertify: '',
      selectedLists: []
    }
  },
  created() {
    this.fnGetDepartmentList()
    this.fnGetHistoryList()
  },
  methods: {
    changeTime(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnGetHistoryList() {
      this.bCreateSendEmployee = false
      this.bShowPaymentDialog = false
      this.$http.getStockMarketList(this.listQuery).then(res => {
        this.tableKey++
        this.exchangeLists = res.data.list
        this.listQuery.total = res.data.count - 0
      })
    },
    fnGetDepartmentList() {
      this.bShowPaymentDialog = false
      this.$http.getDepartmentList().then(res => {
        res.data.forEach((ele) => {
          ele.label = ele.name
        })
        this.departmentList = res.data
      })
    },
    handleSelectionChange(val) {
      this.selectedLists = val
    },
    fnPopPayment() {
      if (this.selectedLists.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择打款用户'
        })
        return
      }
      this.bShowPaymentDialog = true
    },
    fnSubmitConfirmPayment() {
      var self = this
      this.$refs.confirmPaymentForm.validate(valid => {
        if (valid) {
          self.confirmPaymentForm.voucher = '打款时间: ' + self.confirmPaymentForm.time + '   ' +
          '备注: ' + self.confirmPaymentForm.remark
          self.confirmPaymentForm.deal_id = self.selectedLists.map((ele) => { return ele.deal_id }).join(',')
          self.$http.confirmPayment(self.confirmPaymentForm).then(res => {
            if (res.code == 200) {
              self.$refs.multipleTable.clearSelection()
              self.selectedLists = []
              self.$refs['confirmPaymentForm'].resetFields()
              self.fnGetHistoryList()
            }
          })
        }
      })
    },
    fnLookPayProof: function(val) {
      this.currentCertify = val
      this.bShowCertificate = true
    },
    fnPopExchange() {
      if (this.selectedLists.length === 0) {
        if (this.selectedLists.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择用户'
          })
          return
        }
        return
      }
      this.$confirm('是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const deal_id = this.selectedLists.map((ele) => { return ele.deal_id }).join(',')
        this.$http.confirmDeal({ deal_id }).then(res => {
          if (res.code == 200) {
            this.$refs.multipleTable.clearSelection()
            this.selectedLists = []
            this.fnGetHistoryList()
          }
        })
      }).catch(() => {

      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 60px;
            bottom: 0;
            right: 0;
            padding: 30px;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
        }
    }
}
</style>
